module.exports = __webpack_public_path__ + "media/bannerly-lite.10448f94.mp4";